import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
import itemLogsLineChart from './components/itemLogsLineChart';
import m3u8Video from '@/components/m3u8Video';
import dailyReport from './components/dailyReport';
import mockData from './mockData/data.json';
export default {
  components: {
    itemLogsLineChart: itemLogsLineChart,
    m3u8Video: m3u8Video,
    dailyReport: dailyReport
  },
  data: function data() {
    return {
      dayjs: dayjs,
      structures_list: [],
      weatherData: []
    };
  },
  mounted: function mounted() {
    this.getLabArea();
    this.getWeatherData();
  },
  methods: {
    // 获取养殖池
    getLabArea: function getLabArea() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, items, lastRecord, level, itemLog, index, _yield$_this$getDevic;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api['labAreaQuery']({
                labId: localStorage.getItem('labId'),
                sortField: '^sort',
                searchKey: 'Cistern,Pond,Lake'
              });
            case 2:
              res = _context.sent;
              if (!res.data) {
                _context.next = 33;
                break;
              }
              _context.t0 = _regeneratorRuntime().keys(res.data);
            case 5:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 31;
                break;
              }
              index = _context.t1.value;
              if (res.data[index].smartControlId) {
                _context.next = 14;
                break;
              }
              // 没有绑定设备
              lastRecord = [{
                itemName: '溶解氧',
                itemValue: '--',
                itemUnit: 'mg/L'
              }, {
                itemName: '水温',
                itemValue: '--',
                itemUnit: '℃'
              }, {
                itemName: 'PH',
                itemValue: '--',
                itemUnit: ''
              }];
              level = {};
              items = [];
              itemLog = [];
              _context.next = 25;
              break;
            case 14:
              _context.next = 16;
              return _this.getDeviceItem(res.data[index]);
            case 16:
              items = _context.sent;
              _context.next = 19;
              return _this.getDeviceLastRecord(res.data[index].smartControlId, items);
            case 19:
              _yield$_this$getDevic = _context.sent;
              lastRecord = _yield$_this$getDevic.lastRecord;
              level = _yield$_this$getDevic.level;
              _context.next = 24;
              return _this.getDeviceItemLog(res.data[index].smartControlId, items);
            case 24:
              itemLog = _context.sent;
            case 25:
              res.data[index].lastRecord = lastRecord;
              res.data[index].level = level;
              res.data[index].itemLog = itemLog;
              res.data[index].items = items;
              _context.next = 5;
              break;
            case 31:
              _this.structures_list = res.data || [];
              console.log('this.structures_list', _this.structures_list);
            case 33:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getDeviceItem: function getDeviceItem(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var smartControlId, itemGroup, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              smartControlId = _ref.smartControlId, itemGroup = _ref.itemGroup;
              _context2.next = 3;
              return _this2.$api['smartControlItemQuery']({
                page: 1,
                limit: -1,
                typeCategory: 'Monitor',
                smartControlId: smartControlId,
                typeGroup: itemGroup
              });
            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || []);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    } // 环境数据
    ,
    getDeviceLastRecord: function getDeviceLastRecord(smartControlId, items) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, data, _iterator, _step, item, level;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$api['smartControlLastRecord'](smartControlId);
            case 2:
              res = _context3.sent;
              data = [];
              _iterator = _createForOfIteratorHelper(items);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  res.data[item.typeCode] && data.push({
                    predictionCode: item.predictionCode,
                    itemName: item.typeName,
                    itemUnit: item.unit,
                    itemCode: item.typeCode,
                    itemValue: res.data[item.typeCode]
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context3.next = 8;
              return _this3.getWaterLevel(data);
            case 8:
              level = _context3.sent;
              return _context3.abrupt("return", {
                lastRecord: data,
                level: level
              });
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getDeviceItemLog: function getDeviceItemLog(smartControlId, items) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var itemCode, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              itemCode = items.map(function (item) {
                return item.typeCode;
              }).join(',');
              _context4.next = 3;
              return _this4.$api['smartControlTLogQuery'](smartControlId, {
                page: 1,
                limit: 50 * items.length,
                sortField: 'ts'
              });
            case 3:
              res = _context4.sent;
              if (!localStorage.getItem('showSimulate')) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return", res.data || []);
            case 6:
              return _context4.abrupt("return", res.data || []);
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getWeatherData: function getWeatherData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.$api['labWeather'](localStorage.getItem('labInfo') ? JSON.parse(localStorage.getItem('labInfo')).districtCode || '650400' : '370200');
            case 2:
              res = _context5.sent;
              data = JSON.parse(res.data);
              _this5.weatherData = JSON.parse(res.data).result.now;
              console.log('data', data, _this5.weatherData);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getWaterLevel: function getWaterLevel(data) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var val, _iterator2, _step2, item, res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              val = [];
              _iterator2 = _createForOfIteratorHelper(data);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  item.predictionCode !== 'Nothing' && val.push({
                    idx: val.length,
                    itemType: item.predictionCode,
                    itemValue: item.itemValue
                  });
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context6.next = 5;
              return _this6.$api['mathFormulaWaterQualitys'](val);
            case 5:
              res = _context6.sent;
              return _context6.abrupt("return", res.data || {});
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    backClick: function backClick() {
      this.$router.back();
    }
  }
};